export const hriRequestMixin = {
    data() {
        return {
            fileList: [],
            fileChiefList: [],
            errorFile: "",
            stYear: [],
            stMonthBud: [],
            endOpen: false,
        };
    },
    methods: {
        handleStartOpenChange(open) { },
        handleEndOpenChange(open) {
            this.endOpen = open;
        },
        // Generic File Validation
        isValidFile(file) {
            this.errorFile = "";
            if (!file || typeof file !== 'object') {
                this.errorFile = "Invalid file object";
                return false;
            }
            const validTypes = [
                "image/jpg",
                "application/pdf",
                "image/jpeg",
                ".heic",
                "image/png"
            ];
            if (validTypes.includes(file.type)) {
                return true;
            } else {
                this.errorFile = "Found a Problem, please check your results.";
                return false;
            }
        },
        // Generic: File Remove from List
        removeFileFromList(file, listName) {
            if (this[listName]) {
                const index = this[listName].indexOf(file);
                if (index > -1) {
                    const newFileList = this[listName].slice();
                    newFileList.splice(index, 1);
                    this[listName] = newFileList;
                }
            }
        },

        // --- Shared Logic for Fiscal Year ---
        generateBudgetMonths(year, months) {
            if (!year || !Array.isArray(months)) return [];
            const monthArr = [];
            for (const m of months) {
                if (['10', '11', '12'].includes(m)) {
                    monthArr.push(`${year - 1}-${m}`);
                } else {
                    monthArr.push(`${year}-${m}`);
                }
            }
            return monthArr;
        },
        async initBudgetYear() {
            this.stYear = [];
            this.stMonthBud = [];
            const mTemp = ['10', '11', '12', '01', '02', '03', '04', '05', '06', '07', '08', '09'];
            const currentYear = Number.parseInt(this.moment().format("YYYY"));

            // Initial Year List
            this.stYear = [currentYear - 1, currentYear];

            // Initial Month List
            this.stMonthBud = this.generateBudgetMonths(currentYear, mTemp);

            try {
                const res = await this.$http.get(`/hri/leave_of_absence/view_year/`);
                if (res.status === 200) {
                    // Next Fiscal Year Logic
                    if (Number.parseInt(this.moment().format("M")) >= 10) {
                        this.stYear.push(currentYear + 1);
                        const nextYearMonths = this.generateBudgetMonths(currentYear + 1, mTemp);
                        this.stMonthBud = this.stMonthBud.concat(nextYearMonths);
                    }

                    // Max API Year Logic
                    if (res.data.length > 0) {
                        const maxApiYear = Number.parseInt(res.data[res.data.length - 1]['year']);
                        if (currentYear <= maxApiYear) {
                            if (!this.stYear.includes(maxApiYear)) this.stYear.push(maxApiYear);
                            // logic for max year months if different? Assuming standard fiscal year
                            // If maxApiYear is already covered by nextFiscalYear logic, avoid dupes.
                            // Simplified for safe merge:
                            const maxYearMonths = this.generateBudgetMonths(maxApiYear, mTemp);
                            // Uniqueness check could be added but concat usually fine for display logic unless strict
                            this.stMonthBud = [...new Set([...this.stMonthBud, ...maxYearMonths])];
                            this.stYear = [...new Set(this.stYear)];
                        }
                    }
                }
            } catch (error) {
                console.log("Error initializing budget year:", error);
            }
        },
        // Old method kept for compatibility but redirects to initBudgetYear if suitable or stays same
        stBudgetYear() {
            this.initBudgetYear();
        },

        // --- Shared Logic for Calendar Data ---
        async fetchCalendarData(start, end) {
            try {
                const res = await this.$http.get(`/hri/calendar_data/?timestart=${start}&timeend=${end}`);
                if (res.status === 200) {
                    return res.data;
                }
                const error = new Error('Request Failed');
                error.res = res;
                error.response = res;
                throw error;
            } catch (error) {
                this.$notification.open({
                    style: { backgroundColor: "#ff1919", color: "#ffffff" },
                    message: h => h("div", [h("strong", { class: "font-web" }, "Error :: ")]),
                    description: `Problem issue connect api : /hri/calendar_data/`,
                });
                return [];
            }
        },

        // --- Shared Logic for History Requests ---
        async fetchHistoryRequests(endpoint, start, end, paramNames = { start: 'start', end: 'end' }) {
            try {
                if (!endpoint || typeof endpoint !== 'string') return [];
                const separator = endpoint.includes('?') ? '&' : '?';
                const url = `${endpoint}${separator}${paramNames.start}=${start}&${paramNames.end}=${end}`;
                const res = await this.$http.get(url);
                if (res.status === 200) {
                    return res.data.sort((a, b) => b.id - a.id);
                }
            } catch (error) {
                console.error(error);
            }
            return [];
        },
        async loadRequestHistory(endpoint, paramNames) {
            this.loadingList = true;
            this.dataHistory = [];
            let aEnd = this.moment().add(1, "year").format("YYYY");
            let bStart = this.moment(`${Number.parseInt(this.moment().format("YYYY")) - 1}-10-01`).format(
                "YYYY-MM-DD"
            );
            let ee = this.moment(`${aEnd}-09-30`).format("YYYY-MM-DD");
            this.dataHistory = await this.fetchHistoryRequests(endpoint, bStart, ee, paramNames);
            this.loadingList = false;
        },

        handleRemove(file) {
            this.handleGenericRemove(file, 'fileList', 'file_backup', 'formSerminar'); // Try to support legacy
            // Also support generic approach
            this.removeFileFromList(file, 'fileList');
        },
        beforeUpload(file) {
            if (this.isValidFile(file)) {
                this.fileList = [...this.fileList, file];
                // Legacy support
                this.updateFileBackup(file, 'user');
            }
            return false;
        },
        handleChiefRemove(file) {
            this.removeFileFromList(file, 'fileChiefList');
            this.removeFileFromList(file, 'fileListCheif'); // Handle both naming conventions if they exist
        },
        beforeChiefUpload(file) {
            if (this.isValidFile(file)) {
                this.fileChiefList = [...this.fileChiefList, file];
                // Legacy support
                this.updateFileBackup(file, 'chief');
            }
            return false;
        },

        // Helper to remove duplicated code in components
        handleGenericRemove(file, listName, formProp, formName) {
            const index = this[listName].indexOf(file);
            if (index > -1) {
                const newFileList = this[listName].slice();
                newFileList.splice(index, 1);
                this[listName] = newFileList;
                if (this[formName] && this[formName][formProp]) {
                    this[formName][formProp] = null;
                }
            }
        },

        gotoMainType() {
            this.$router.push({ path: "/hri/request" }).catch((err) => { });
        },
        updateFileBackup(file, type) {
            if (this.formSerminar) {
                if (type === 'user') this.formSerminar.file_backup = file;
                if (type === 'chief') this.formSerminar.chief_backup = file;
            } else if (this.formTravel) {
                if (type === 'user') this.formTravel.file_backup = file;
                if (type === 'chief') this.formTravel.chief_backup = file;
            }
        }
    },
};
